export function actionSetCfgOffers(value) {
    return {
        type: 'SET_CFG_OFFERS',
        value: value
    };
}
